
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";

    import Utils from "@/utilities/Utils";

    import PrintTextBox from "@/vue/components/PrintForm/PrintTextBox.vue";
    import PrintTextArea from "@/vue/components/PrintForm/PrintTextArea.vue";
    import PrintCheckbox from "@/vue/components/PrintForm/PrintCheckbox.vue";
    import PrintDatePicker from "@/vue/components/PrintForm/PrintDatePicker.vue";
    import PrintDateTimePicker from "@/vue/components/PrintForm/PrintDateTimePicker.vue";
    import PrintSelect from "@/vue/components/PrintForm/PrintSelect.vue";

    import { WorkPermit } from "@/model/workPermits/WorkPermit";
    import { Site } from "@/model/Site";
    import { ILookupItem, LookupItem } from "@/model/LookupItem";

    @Component({
        components: {
            PrintDatePicker,
            PrintDateTimePicker,
            PrintTextBox,
            PrintTextArea,
            PrintCheckbox,
            PrintSelect
        }
    })
    export default class SouthEasternAfterPart extends Vue {

        @Prop({ required: true }) workPermit!: WorkPermit;
        @Prop({ default: false }) isReadOnly!: boolean;
        @Prop({ required: true }) site!: Site;

        get primaryLocationOptions(): Array<ILookupItem> {
            if(Utils.isEmptyId(this.workPermit.siteID)) return [LookupItem.createLookup("", "(select a site first)")];
            if(this.site.isNew) return [LookupItem.createLookup("", "(loading...)")];
            const lookups = [
                LookupItem.createLookup("", "please select..."),
                ...this.site.permitLocations.map(l => LookupItem.createLookup(l.description, l.description))
            ];
            return lookups;
        }

        get secondaryLocationOptions(): Array<ILookupItem> {
            if(Utils.isEmptyId(this.workPermit.siteID)) return [LookupItem.createLookup("", "(select a site first)")];
            if(this.site.isNew) return [LookupItem.createLookup("", "(loading...)")];
            const primaryLoc = this.site.permitLocations.find(l => l.description === this.workPermit.southEasternFieldSet.primaryLocation);
            if(!primaryLoc) return [LookupItem.createLookup("", "(select a primary location first)")];
            const lookups = [
                LookupItem.createLookup("", "please select..."),
                ...primaryLoc.subLocations.map(l => LookupItem.createLookup(l.description, l.description))
            ];

            // deselect if not in list
            if(lookups.filter(l => l.id === this.workPermit.southEasternFieldSet.secondaryLocation).length === 0) {
                this.workPermit.southEasternFieldSet.secondaryLocation = "";
            }

            return lookups;
        }

        get zoneOptions(): Array<ILookupItem> {
            if(Utils.isEmptyId(this.workPermit.siteID)) return [LookupItem.createLookup("", "(select a site first)")];
            if(this.site.isNew) return [LookupItem.createLookup("", "(loading...)")];
            const lookups = [
                LookupItem.createLookup("", "please select..."),
                ...this.site.permitZones.map(l => LookupItem.createLookup(l.description, l.description))
            ];
            return lookups;
        }


    }
